<template>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
<path fill="#56D0E0" d="M224 320h-48v-0.976c-5.28 0.544-10.576 0.976-16 0.976-88.352 0-160-71.632-160-160s71.648-160 160-160 160 71.632 160 160v64h16v16h16v16h16v16h16v16h16v16h16v16h16v16h16v16h16v16h16v16h16v16h16v96c0 8.848-7.152 16-16 16h-64c-8.848 0-16-7.152-16-16v-64h-80c-8.832 0-16-7.152-16-16v-64h-80zM128 64c-35.344 0-64 28.656-64 64s28.656 64 64 64 64-28.656 64-64-28.656-64-64-64z"></path>
</svg>
</template>
